import { FC, useEffect } from 'react';

import {
  useCurrentProjectId,
  useCurrentAccountId,
  useUser,
} from '@adsk/alloy-provider';

import { useLaunchDarklyData } from './LaunchDarklyProvider';

const ACCLaunchDarklySubscriber: FC = () => {
  const projectId = useCurrentProjectId();
  const accountId = useCurrentAccountId();
  const { user } = useUser();
  const { setUser, setProjectId, setAccountId } = useLaunchDarklyData();

  useEffect(() => {
    setUser({ analyticsId: user?.analyticsId, email: user?.email });
  }, [user, setUser]);

  useEffect(() => {
    setProjectId(projectId);
  }, [projectId, setProjectId]);

  useEffect(() => {
    setAccountId(accountId);
  }, [accountId, setAccountId]);

  return null;
};

export default ACCLaunchDarklySubscriber;
